import _ from 'lodash';
import {
  BrokerNode, DiscovererOptions, Discoverers, LoggerInstance, ServiceRegistry
} from 'moleculer';

export default class ServiceDiscoverer extends Discoverers.Local {
  public opts: DiscovererOptions;

  public registry: ServiceRegistry;

  public logger: LoggerInstance;

  /**
   * Creates an instance of Discoverer.
   *
   * @memberof BaseDiscoverer
   */
  constructor(opts: DiscovererOptions) {
    super(opts);
    this.opts = _.defaultsDeep(
      {},
      opts,
      {
        // heartbeatInterval: null,
        // heartbeatTimeout: null,
        // disableHeartbeatChecks: false,
        // disableOfflineNodeRemoving: false,
        cleanOfflineNodesTimeout: 30, // 30 seconds
      },
      this.opts,
    ) as DiscovererOptions;
  }

  disableHeartbeat() {
    this.stopHeartbeatTimers();
  }

  /**
   * Check offline nodes. Remove which is older than 10 minutes.
   */
  checkOfflineNodes() {
    if (this.opts.disableOfflineNodeRemoving || !this.opts.cleanOfflineNodesTimeout) return;

    const now = Math.round(process.uptime());
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    (this.registry.nodes.toArray() as BrokerNode[]).forEach((node) => {
      if (node.local || node.available || node.id === this.opts.tcpDiscoveryNodeId) return;
      if (!node.lastHeartbeatTime) {
        // Not received the first
        // eslint-disable-next-line no-param-reassign
        node.lastHeartbeatTime = now;
        return;
      }

      const lastSeen = now - node.lastHeartbeatTime;
      if (lastSeen > this.opts.cleanOfflineNodesTimeout) {
        this.logger.warn(`Removing offline '${node.id}' node from registry because it hasn't submitted heartbeat signal for ${lastSeen} seconds.`);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        this.registry.nodes.delete(node.id);
      }
    });
  }
}
